const DEFAULT_FALLBACK = 'Please try again.'

export default function getCartUserMessage(error, fallback = DEFAULT_FALLBACK) {
  if (error == null || error === '') return fallback
  if (typeof error === 'string') return error
  if (typeof error === 'object' && error.message) return error.message
  return fallback
}
